<script lang="ts">
import { defineComponent, toRaw } from 'vue';
import { mapGetters } from 'vuex';
import SolutoButton from '../../components/SolutoButton.vue';

export default defineComponent({
  name: 'CallEnd',
  components: {
    Button: SolutoButton
  },
  computed: {
    ...mapGetters([
      'permission',
      'recommendationScale',
      'recommendationComment',
      'faqViewStatus',
      'faqHelpfulnessScale',
      'faqUnhelpfulnessReasons',
      'faqUnhelpfulnessOtherReason',
      'supportHelpfulnessScale',
      'supportUnhelpfulnessReason',
      'supportUnhelpfulnessOtherReason',
      'hasBeenResolved',
      'getAge',
      'getGender',
      'type',
      'deviceSupportFeedbackRequest',
      'deviceSupportNeeds',
      'continueSupportService',
      'supportServiceComment',
      'supportServiceRating',
      'enquiryRating',
      'operatorRating',
      'literacy'
    ]),
    getLiteracyValue () {
      const literacyOptions = [
        this.$t('survey_18_checkbox_0'),
        this.$t('survey_18_checkbox_1'),
        this.$t('survey_18_checkbox_2')
      ];
      const index = literacyOptions.indexOf(this.literacy);
      return index !== -1 ? `${index + 1}-${this.literacy}` : '';
    }
  },
  created () {
    window.parent.postMessage(
      {
        solutoSubmit: {
          type: this.type,
          isAgreed: this.permission,
          recommendationScale: this.recommendationScale,
          recommendationComment: this.recommendationComment,
          faqViewStatus: this.faqViewStatus,
          faqHelpfulnessScale: this.faqHelpfulnessScale,
          faqUnhelpfulnessReasons: toRaw(this.faqUnhelpfulnessReasons),
          faqUnhelpfulnessOtherReason: this.faqUnhelpfulnessOtherReason,
          supportHelpfulnessScale: this.supportHelpfulnessScale,
          supportUnhelpfulnessReason: this.supportUnhelpfulnessReason,
          supportUnhelpfulnessOtherReason: this.supportUnhelpfulnessOtherReason,
          hasBeenResolved: this.hasBeenResolved,
          age: this.getAge,
          gender: this.getGender,
          ...(this.deviceSupportFeedbackRequest ? { feedBackRequests: this.deviceSupportFeedbackRequest } : {}),
          ...(this.deviceSupportNeeds ? { feedBackNeeds: this.deviceSupportNeeds } : {}),
          ...(this.continueSupportService ? { cssNrsRaw: this.continueSupportService } : {}),
          ...(this.supportServiceComment ? { feedbackGoodPoints: this.supportServiceComment } : {}),
          ...(this.supportServiceRating ? { cssAppCsat: this.supportServiceRating } : {}),
          ...(this.enquiryRating ? { cssCsat: this.enquiryRating } : {}),
          ...(this.operatorRating ? { cssOps: this.operatorRating } : {}),
          ...(this.getLiteracyValue ? { cssLiteracy: this.getLiteracyValue } : {})
        }
      }, '*'
    );
  },
  methods: {
    gotoHome () {
      window.parent.postMessage(
        { solutoSurvey: 'finishSurvey' }, '*'
      );
    }
  }
});
</script>

<template>
  <div class="survey-end-page">
    <div class="survey-end">
      <div class="survey-end-pic">
        <img class="pic" src="../../assets/group.svg" alt="" />
      </div>
      <p class="survey-end-title">{{ $t('callend_01') }}</p>
      <p class="survey-end-subtitle">{{ $t('callend_02') }}</p>
    </div>
    <div class="survey-end-footer">
      <Button
        class="survey-end-footer-button"
        :size="'large'"
        :text="$t('go to my page')"
        @click="gotoHome()"
      />
    </div>
  </div>
</template>

<style lang="scss" scoped>
.survey-end-page {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  min-height: 100vh;
  background-color: $survey-background-color;
}

.survey-end {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 24px 16px 0;
  text-align: left;

  &-pic {
    width: 100%;
    display: flex;
    justify-content: center;
  }

  .pic {
    width: 324px;
    max-width: 100%;
    height: auto;
  }

  &-title {
    width: 100%;
    margin: 24px 0 0;
    font-family: $font-family;
    font-size: 18px;
    font-weight: 700;
    line-height: 1.3;
    color: #000000;
  }

  &-subtitle {
    width: 100%;
    margin: 18px 0 0;
    color: $survey-text-color;
    font-family: $font-family;
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: 1.5;
  }
}

.survey-end-footer {
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 24px 18px 18px;
  background-color: $survey-background-color;

  &-button {
    width: 100%;
  }
}
</style>
